import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { Section } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { extendedMediaStrings } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/media";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var ValuePropositionSection = function() {
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isDesktopAndAbove = _useViewport.isDesktopAndAbove;
    return /*#__PURE__*/ _jsxs(CustomSection, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.inverse,
                align: "center",
                variant: {
                    xLargeAndAbove: "displayLSerifRegular",
                    desktopAndAbove: "displayMSerifRegular",
                    mobileAndAbove: "pageHeaderSerifRegular"
                },
                children: isMobile ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "01pgxW",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We believe small businesses"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "are vital to our communities"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        lineBreak: /*#__PURE__*/ _jsx("br", {})
                    })
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "JLGpJo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We believe small businesses are"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "vital to our communities"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        lineBreak: /*#__PURE__*/ _jsx("br", {})
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: isDesktopAndAbove ? "3x" : "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                color: Core.text.inverse,
                variant: {
                    desktopAndAbove: "subheadingSansRegular",
                    mobileAndAbove: "paragraphSansRegular"
                },
                children: isMobile ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "FTWtse",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "It\u2019s why we come to work every day\u2014"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "to help independent shopkeepers,"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "makers, and artisans across the globe"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "build thriving and successful businesses."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        lineBreak: /*#__PURE__*/ _jsx("br", {})
                    })
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "NaunPY",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "It\u2019s why we come to work every day\u2014to help"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "independent shopkeepers, makers, and artisans across"
                        },
                        {
                            type: 1,
                            value: "lineBreak"
                        },
                        {
                            type: 0,
                            value: "the globe build thriving and successful businesses."
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        lineBreak: /*#__PURE__*/ _jsx("br", {})
                    })
                })
            })
        ]
    });
};
var CustomSection = styled(Section).attrs({
    align: "center",
    justify: "center",
    $withHorizontalPadding: true,
    $withVerticalPadding: true,
    $backgroundColor: Decorative.shade.yellow
}).withConfig({
    componentId: "sc-2e278ffd-0"
})([
    "",
    ",",
    "{padding-top:104px;padding-bottom:104px;}"
], responsiveMediaQueries.desktop, extendedMediaStrings.xlarge);
